export default function userAgentInfoReducer(state = {}) {
  return state;
}
